// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2zUhv","content":"LayoutSettings_content__1zsQ6"};